import { Component, OnInit, ɵConsole ,Input } from '@angular/core';
import { Service } from '../../services';
import { GlobalService } from '../../global.service';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-paperless-box',
  templateUrl: './paperless-box.component.html',
  styleUrls: ['./paperless-box.component.sass']
})
export class PaperlessBoxComponent implements OnInit {
  public paperless=false;
  @Input() email;
  public newEmail;
  @Input() currentBan;
  @Input() loadingData;
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService) { }

  ngOnInit() {
    this.paperless=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    
    if(this.loadingData!=false){
    }
    else{
      this.newEmail='';
    }
  }
  updatepaperless(){
    if(this.global.validateSession()===true){
      if(this.paperless==false){
        this.loadingScreenService.startLoadingMin();
        let token=JSON.parse(atob(sessionStorage.getItem("getAcoout"))).token;
          this.services.updatePaperless(this.currentBan,token).subscribe(data =>{
            if(data.HasError ==false){
              this.paperless=true;
              this.loadingScreenService.stopLoadingMin();
              if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
                this.global.notif(data.ErrorDesc);
              }
            }
            else{
              this.loadingScreenService.stopLoadingMin();
              this.global.notif(data.ErrorDesc);
            }
          });
        
      }else{
        this.paperless=false;
      }
    }
  }

}
